import { current } from '@reduxjs/toolkit'
import immerize from '../immerize'
import ensurePath from 'redux/ensurePath'

const initState = {
  status: '',
  error: null,
  actives: {
    data: {
      byid: {},
      list: [],
    },
    pagination: {
      count: 0,
      total: 0,
      currentPage: 1,
      itemPerPage: 10,
      pageCount: 1,
    },
  },
  archived: {
    data: {
      byid: {},
      list: [],
    },
    pagination: {
      count: 0,
      total: 0,
      currentPage: 1,
      itemPerPage: 10,
      pageCount: 1,
    },
  },
  reports_new: 0,
  reports_today: 0,
}

function reducer(state = initState, action) {
  switch (action.type) {
    case 'CLEAR_STORE':
      state = initState
      break
    case 'REPORTS_STATISTICS_COUNT':
      state.error = null
      state.status = 'REPORTS_STATISTICS_COUNT'
      state.reports_new = action.payload.data.reports_new
      state.reports_today = action.payload.data.reports_today
      break
    case 'REPORTS_STATISTICS_FULFILLED':
      state.error = null
      state.status = 'REPORTS_STATISTICS_FULFILLED'
      state.reports_new = action.payload.data.new
      state.reports_today = action.payload.data.today
      break
    case 'REPORTS_ACTIVE_FULFILLED':
      reportsActiveFulfilled(state, action.payload.data)
      break
    case 'REPORTS_ACTIVES_ITEMPERPAGE':
      reportsActivesItemperpage(state, action.payload.count)
      break
    case 'REPORTS_ACTIVE_CURRENTPAGE':
      reportsActivesCurrentPage(state, action.payload.page)
      break
    case 'REPORTS_ACTIVE_NEW':
      reportsActivesNew(state)
      break
    case 'REPORTS_READ_FULFILLED':
      reportsReadFulfilled(state, action.payload.data)
      break
    case 'REPORTS_ARCHIVE_FULFILLED':
      reportsArchiveFulfilled(state, action.payload.data)
      break
    case 'REPORTS_UNREAD_FULFILLED':
      reportsUnreadFulfilled(state, action.payload.data)
      break
    case 'REPORTS_ACTION_NEW':
      reportsAddRemark(state, action.payload.data)
      break
    case 'REPORTS_ARCHIVED_FULFILLED':
      reportsArchivedFulfilled(state, action.payload.data)
      break
    case 'REPORTS_ARCHIVED_ITEMPERPAGE':
      reportsArchivedItemPerPage(state, action.payload.count)
      break
    case 'REPORTS_ARCHIVED_CURRENTPAGE':
      reportsArchivedCurrentPage(state, action.payload.page)
      break
    case 'REPORTS_UNARCHIVED_FULFILLED':
      reportsUnarchivedFulfilled(state, action.payload.data)
      break
    default:
      return state
  }
  return state
}

function reportsActiveFulfilled(state, info) {
  const targetActivesPagination = ensurePath(state, ['actives', 'pagination'])
  const targetActivesData = ensurePath(state, ['actives', 'data'])
  const targetActivesDataByid = ensurePath(state, ['actives', 'data', 'byid'])

  const snapshot = current(state)
  const incoming = normalizeActiveReports(info)

  const currentPaginationTotal = snapshot.actives.pagination.total ?? 0

  let pCount = Math.ceil(
    incoming.total / snapshot.actives.pagination.itemPerPage
  )
  if (pCount < 1) pCount = 1
  targetActivesPagination.count = incoming.total
  targetActivesPagination.total = incoming.total
  targetActivesPagination.pageCount = pCount
  Object.keys(incoming.reports.byid).forEach((key) => {
    targetActivesDataByid[key] = incoming.reports.byid[key]
  })

  let _list = [...snapshot.actives.data.list]
  if (_list.length < 1 || currentPaginationTotal !== incoming.total) {
    _list = new Array(incoming.total).fill(-1)
  }

  _list.splice(
    incoming.skip,
    incoming.reports.list.length,
    ...incoming.reports.list
  )
  targetActivesData.list = _list
}

function reportsActivesItemperpage(state, count) {
  const targetActivesPagination = ensurePath(state, ['actives', 'pagination'])
  const pagination = current(state.actives.pagination)

  let pCount = Math.ceil(pagination.total / count)
  if (pCount < 1) pCount = 1

  targetActivesPagination.itemPerPage = count
  targetActivesPagination.pageCount = pCount
  targetActivesPagination.currentPage = 1
}

function reportsActivesCurrentPage(state, page) {
  const targetActivesPagination = ensurePath(state, ['actives', 'pagination'])
  targetActivesPagination.currentPage = page
}

function reportsActivesNew(state) {
  const targetActivesData = ensurePath(state, ['actives', 'data'])
  const targetActivesPagination = ensurePath(state, ['actives', 'pagination'])

  const snapshot = current(state)
  const total = snapshot.actives.pagination.total + 1
  const itemPerPage = snapshot.actives.pagination.itemPerPage

  targetActivesPagination.total = total

  let pageCount = Math.ceil(total / itemPerPage)
  if (pageCount < 1) pageCount = 1
  targetActivesPagination.pageCount = pageCount

  targetActivesData.list.splice(0, 0, -1)
}

function reportsReadFulfilled(state, info) {
  const activesDataByid = ensurePath(state, ['actives', 'data', 'byid'])
  const archivedDataByid = ensurePath(state, ['archived', 'data', 'byid'])

  const reportId = '' + info.report.id ?? null

  if (activesDataByid[reportId]) {
    state.reports_new = info.count_new
    activesDataByid[reportId].isRead = true
    return
  }

  if (archivedDataByid[reportId]) {
    state.reports_new = info.count_new
    archivedDataByid[reportId].isRead = true
  }
}

function reportsArchiveFulfilled(state, info) {
  const activesData = ensurePath(state, ['actives', 'data'])
  const activesDataByid = ensurePath(state, ['actives', 'data', 'byid'])
  const activesPagination = ensurePath(state, ['actives', 'pagination'])

  const archivedData = ensurePath(state, ['archived', 'data'])
  const archivedDataByid = ensurePath(state, ['archived', 'data', 'byid'])
  const archivedPagination = ensurePath(state, ['archived', 'pagination'])

  const reportId = '' + info.report.id
  if (!activesDataByid[reportId]) {
    return
  }

  const reportToBeArchived = activesDataByid[reportId]
  // Remove report from actives.data.byid and actives.data.list and update actives.pagination
  if (activesData.list) {
    const indexOfReport = activesData.list.indexOf(info.report.id)
    if (indexOfReport !== -1) {
      activesData.list.splice(indexOfReport, 1)
    }
  } else {
    activesData.list = []
  }

  activesPagination.total = activesPagination.total
    ? activesPagination.total - 1
    : 0
  let activesPageCount = Math.ceil(
    activesPagination.total / activesPagination.itemPerPage
  )
  if (activesPageCount < 1) activesPageCount = 1
  activesPagination.pageCount = activesPageCount

  let activesCurrentPage = activesPagination.currentPage
  if (activesCurrentPage > activesPageCount) {
    activesCurrentPage = activesPageCount
  }
  activesPagination.currentPage = activesCurrentPage
  delete activesDataByid[reportId]

  // insert the data into archived
  if (!archivedData.list) {
    archivedData.list = []
    return
  }
  if (archivedData.list.length < 1) {
    return
  }

  archivedPagination.total = archivedPagination.total ?? 0
  archivedPagination.count = archivedPagination.count ?? 0
  archivedPagination.itemPerPage = archivedPagination.itemPerPage ?? 10

  let archivedPageCount = Math.ceil(
    (archivedPagination.total + 1) / archivedPagination.itemPerPage
  )
  if (archivedPageCount < 1) {
    archivedPageCount = 1
  }

  archivedPagination.pageCount = archivedPageCount
  archivedPagination.total = archivedPagination.total + 1
  archivedPagination.count = archivedPagination.count + 1

  reportToBeArchived.isDeleted = true
  archivedDataByid[reportId] = reportToBeArchived
  archivedData.list.splice(0, 0, -1)
}

function reportsUnreadFulfilled(state, info) {
  const reportId = '' + info.report.id
  const byid = ensurePath(state, ['actives', 'data', 'byid'])
  if (!byid[reportId]) {
    return state
  }
  state.reports_new = info.count_new
  byid[reportId].isRead = false
}

function reportsAddRemark(state, remarkData) {
  const reportId = '' + remarkData.reportId
  const byid = ensurePath(state, ['actives', 'data', 'byid'])
  if (!byid[reportId]) {
    return
  }

  if (typeof byid[reportId].actions === 'undefined') {
    byid[reportId].actions = []
  }
  if (
    byid[reportId].actions.find((a) => {
      return a.id === remarkData.id
    })
  ) {
    return
  }
  byid[reportId].actions.splice(byid[reportId].actions.length, 0, remarkData)
}

function reportsArchivedFulfilled(state, archivedList) {
  const normalizedArchived = normalizeArchivedReports(archivedList)
  const pagination = ensurePath(state, ['archived', 'pagination'])
  const data = ensurePath(state, ['archived', 'data'])
  const byid = ensurePath(state, ['archived', 'data', 'byid'])

  let pCount = Math.ceil(normalizedArchived.total / pagination.itemPerPage)
  if (pCount < 1) pCount = 1
  pagination.count = normalizedArchived.total
  pagination.total = normalizedArchived.total
  pagination.pageCount = pCount

  Object.keys(normalizedArchived.reports.byid).forEach((key) => {
    byid[key] = normalizedArchived.reports.byid[key]
  })

  if (!data.list) {
    data.list = []
  }
  if (data.list.length < 1 || pagination.total !== normalizedArchived.total) {
    data.list = new Array(pagination.total).fill(-1)
  }
  data.list.splice(
    normalizedArchived.skip,
    normalizedArchived.reports.list.length,
    ...normalizedArchived.reports.list
  )
}

function reportsArchivedItemPerPage(state, count) {
  const pagination = ensurePath(state, ['archived', 'pagination'])

  let pCount = Math.ceil(pagination.total / count)
  if (pCount < 1) pCount = 1

  pagination.itemPerPage = count
  pagination.pageCount = pCount
  pagination.currentPage = 1
}

function reportsArchivedCurrentPage(state, page) {
  const pagination = ensurePath(state, ['archived', 'pagination'])
  pagination.currentPage = page
}

function reportsUnarchivedFulfilled(state, info) {
  const reportId = '' + info.report.id

  const archivedData = ensurePath(state, ['archived', 'data'])
  const archivedByid = ensurePath(state, ['archived', 'data', 'byid'])
  const archivedPagination = ensurePath(state, ['archived', 'pagination'])

  const activesData = ensurePath(state, ['actives', 'data'])

  if (!archivedByid[reportId]) {
    return
  }
  if (!archivedData.list) {
    archivedData.list = []
  }

  const index = archivedData.list.indexOf(info.report.id)
  if (index !== -1) {
    archivedData.list.splice(index, 1)
  }

  const total = archivedPagination.total - 1
  let pageCount = Math.ceil(total / archivedPagination.itemPerPage)
  if (pageCount < 1) pageCount = 1

  let currentPage = archivedPagination.currentPage
  if (currentPage > pageCount) {
    currentPage = pageCount
  }
  archivedPagination.currentPage = currentPage
  archivedPagination.pageCount = pageCount
  archivedPagination.total = archivedPagination.total
    ? archivedPagination.total - 1
    : 0

  activesData.byid = {}
  activesData.list = []
  state.pagination = {
    count: 0,
    total: 0,
    currentPage: 1,
    itemPerPage: 10,
    pageCount: 1,
  }
  delete archivedByid[reportId]
}

/**
 * -----------------------------------------------------------------------
 * Normalizers
 * ----------------------------------------------------------------------
 */
function normalizeActiveReports(actives) {
  let { reports, ..._actives } = actives
  const _reports = {
    byid: {},
    list: [],
  }
  reports.forEach((r) => {
    _reports.list.push(r.id)
    _reports.byid[r.id] = r
  })
  _actives = { ..._actives, reports: { ..._reports } }
  return _actives
}
function normalizeArchivedReports(archived) {
  let { reports, ..._archived } = archived
  const _reports = {
    byid: {},
    list: [],
  }
  reports.forEach((r) => {
    _reports.list.push(r.id)
    _reports.byid[r.id] = r
  })
  _archived = { ..._archived, reports: { ..._reports } }
  return _archived
}

export default immerize(reducer)
